import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import { ExamesNaviosModel } from "./exames-navios.model";
import { ExamesNaviosService } from './exames-navios.service';
import { Funcoes } from "../../funcoes";
import { Global } from "../../global";

@Component({
  selector: 'app-exames-navios-form',
  templateUrl: './exames-navios-form.component.html'
})
export class ExamesNaviosFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  navio: ExamesNaviosModel = new ExamesNaviosModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private examesNaviosService: ExamesNaviosService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id: [],
      nome: ['', [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(100)
      ]],
      imo: ['', [
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(50)
      ]]
    });
  }

  ngOnInit() {
    if (this.router.url.split(/\//).pop() == 'upd') {
      this.pageIsUpd = true;
    }

    if (this.router.url.split(/\//).pop() == 'add') {
      this.pageIsAdd = true;
    }

    this.route.params.subscribe(params => {
      var id = params['id_navio'];

      if (!this.pageIsUpd) {
        this.title = this.func.traduzir('front.visualizarNavio');
      } else {
        this.title = id ? this.func.traduzir('front.editarNavio') : this.func.traduzir('front.cadastrarNovoNavio');
      }

      if (this.pageIsAdd) {
        this.title = this.func.traduzir('front.cadastrarNovoNavio');
      }

      if (!id) {
        return;
      }

      this.examesNaviosService.getById(id)
        .subscribe(
          json => {
            if (this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarNavio') + ': ' + json.Payload[0].nome;
            } else {
              this.title = this.func.traduzir('front.visualizarNavio') + ': ' + json.Payload[0].nome;
            }

            this.navio = json.Payload[0];

            if (this.global.debug == true) {
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    var result,
      values = this.form.value;

    if (values.nome) {
      values.nome = values.nome.toUpperCase();
    }
    if (values.imo) {
      values.imo = values.imo.toUpperCase();
    }

    if (values.id) {
      result = this.examesNaviosService.editar(values, values.id);
    } else {
      result = this.examesNaviosService.adicionar(values);
    }

    result.subscribe(
      data => this.router.navigate(['/painel', 'exames', 'navios']),
      error => {
        this.enviando = false;
        this.func.showErro(error.json());
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/exames/navios/exames-navios-form.component.ts